var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-radio" }, [
    _c(
      "div",
      { staticClass: "v-radio__list", attrs: { name: _vm.name } },
      _vm._l(_vm.optionList, function (item) {
        return _c(
          "label",
          {
            key: item.value,
            staticClass: "v-radio__item",
            class: {
              "v-radio__item--disabled": _vm.isDisabled || item.disabled,
            },
            on: {
              click: function ($event) {
                return _vm.clickRadio(item)
              },
            },
          },
          [
            _c("span", {
              staticClass: "v-radio__icon",
              class: [
                item.value === _vm.value
                  ? "v-radio__icon--active v-icon-radio-checked"
                  : "v-icon-radio",
              ],
              attrs: { value: item.value, "data-name": _vm._name },
            }),
            _c("span", { staticClass: "v-radio__label" }, [
              _vm._v(_vm._s(item.label)),
            ]),
            item.tips
              ? _c(
                  "span",
                  { staticClass: "v-radio__label v-radio__label_tips" },
                  [_vm._v(_vm._s(item.tips))]
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }